export type ExtractionMatchStatus = "NEW" | "DUPLICATE" | "UPDATE";

export interface ProposedOperationalError {
  code?: string | null;
  errorStrings?: string[];
  message?: string | null;
  description?: string | null;
  remediation?: string | null;
  httpStatus?: number | null;
  category?: string | null;
}

export interface OperationalErrorExtractionRow {
  proposed: ProposedOperationalError;
  matchStatus: ExtractionMatchStatus;
  existingUuid?: string | null;
  confidence?: string;
  sourceExcerpt?: string;
}

const EXTRACTION_RE =
  /```operational-error-extraction\s*([\s\S]*?)```/i;

export function parseOperationalErrorExtractions(
  content: string,
): OperationalErrorExtractionRow[] {
  const match = content.match(EXTRACTION_RE);
  if (!match?.[1]) return [];
  try {
    const parsed = JSON.parse(match[1].trim()) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed as OperationalErrorExtractionRow[];
  } catch {
    return [];
  }
}
